import { ComboItemModifierOptionViewModel } from 'store/models/sellModels'

export const hasComboModifierSetting = (
    comboChoiceItemModifierOptions: ComboItemModifierOptionViewModel[],
    comboChoiceItemId: string,
    entityModifierId: string,
) => {
    return comboChoiceItemModifierOptions.some(
        isSameComboModifier(entityModifierId, comboChoiceItemId),
    )
}
export const findComboModifierSetting = (
    f: ComboItemModifierOptionViewModel,
    data: {
        modifierOptionID: string
        comboChoiceItemId: string
        entityModifierId: string
        itemVariantCombinationIds: string
    },
) =>
    f.modifierOptionID === data.modifierOptionID &&
    f.comboChoiceItemID === data.comboChoiceItemId &&
    f.bindingModifierId === data.entityModifierId &&
    (!f.combinationIndices ||
        f.combinationIndices === data.itemVariantCombinationIds)

export function isSameComboModifier(
    entityModifierId: string,
    comboChoiceItemId: string,
): (
    value: ComboItemModifierOptionViewModel,
    index: number,
    array: ComboItemModifierOptionViewModel[],
) => unknown {
    return (c) =>
        entityModifierId === c.bindingModifierId &&
        c.comboChoiceItemID === comboChoiceItemId
}
